import {MathServerClient} from "gradarius-client";

const testMode = true;
const mathServerAddress = "https://grd.math-editor.com/";

let client:MathServerClient;

export function getMathServerClient(): MathServerClient {
  if(!client) {
    client = new MathServerClient(mathServerAddress);
  } 
  return client;
} 

export function toApiUrl(method:string):string {
  if(testMode) {
    return "/testapi/"+method+".json";
  }
  else {
    return "/api/"+method;
  }
}

export function newGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,  (c)=>{
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
